import ExpressionResolver from '../store/modules/form/helpers/expression-resolver-store'
import {
  isSqlSelect,
  isNumber,
  isMultiselect,
  isScalar,
  FIELDS_RE,
  FIELD_NEW_RE,
  OLD_FORMAT_RE,
  EXPRESSION_NEW_FORMAT,
  EXPRESSION_OLD_FORMAT,
} from '../form'
import { get, isEmpty, isNil } from 'lodash'
// import { memorizeMatch } from '@spartancode/memorize' hibásan működik

/**
 * @description Value casting based on field type
 * @param input
 * @param value
 * @returns {*|string|*[]}
 */
export function prepareValue(input, value) {
  if (isSqlSelect(input)) {
    if (Array.isArray(value)) {
      return value
    } else {
      if (!isNil(value) && isNumber(value)) return [value]
      return []
    }
  }

  if (isNil(value)) {
    return ''
  }

  if (isMultiselect(input) && isScalar(value)) {
    return [value]
  }

  return value
}

function removeOldFormatNotation(expression) {
  return expression.replace(OLD_FORMAT_RE, '')
}

/**
 * @description Resolves filterExpression
 * @param expression
 * @param sfRowIndex
 * @param fieldGetter
 * @param fieldPathMap
 * @param namespace
 * @returns {Promise<any>}
 */
export async function getFilter({ expression, sfRowIndex, fieldGetter, fieldPathMap, namespace }) {
  if (expression.includes(EXPRESSION_NEW_FORMAT)) {
    return ExpressionResolver.resolve({
      expression,
      sfRowIndex,
      namespace,
    })
  } else if (expression.includes(EXPRESSION_OLD_FORMAT)) {
    expression = removeOldFormatNotation(expression)
  }
  expression = substituteField({
    expression,
    fieldGetter,
    fieldPathMap,
  })
  return JSON.parse(expression)
}

/**
 * @description Replaces Field expressions to values in filterExpressions
 * @param expression
 * @param fieldGetter
 * @param fieldPathMap
 * @returns {*}
 */
function substituteField({ expression, fieldGetter, fieldPathMap }) {
  const oldFieldMatches = expression.match(FIELDS_RE) // memorizeMatch(expression, FIELDS_RE)
  const newFieldMatches = expression.match(FIELD_NEW_RE) // memorizeMatch(expression, FIELD_NEW_RE) // @todo hibás cache

  if (!isEmpty(newFieldMatches)) {
    newFieldMatches.forEach((match) => {
      const [, fieldName, prop = 'value'] = match.match(
        /field\(['"](\w+)['"](?:,\s*['"](\w+)['"]\))?/ // @regex gets dependency name and property into capture groups
      )
      const fieldPath = fieldPathMap[fieldName]
      const field = fieldGetter(fieldPath)
      const fieldValue = get(field, prop)
      const regexp = new RegExp(`${match.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')}`, 'g') //@regex escape characters

      expression = expression.replace(regexp, fieldValue)
    })
  }

  if (!isEmpty(oldFieldMatches)) {
    oldFieldMatches.forEach((match) => {
      const [, fieldName, prop = 'value'] = match.match(
        /Fields\.(\w+)\.(\w+)/ // @regex gets dependency name and property into capture groups
      )
      const fieldPath = fieldPathMap[fieldName]
      const field = fieldGetter(fieldPath)
      const fieldValue = get(field, prop)
      const regexp = new RegExp(match, 'g')

      expression = expression.replace(regexp, fieldValue)
    })
  }

  return expression
}
